import React from 'react';
import ReactDOM from 'react-dom';
import ShareButtons from './ShareButtons.js'

const elements = [...document.querySelectorAll('.wp-block-salsa-blocks-share-buttons')]
elements.forEach(element => {
    if (element && element.dataset) {
        const {
            url,
            title
        } = element.dataset
        ReactDOM.render(
            <React.StrictMode>
                <ShareButtons url={url} title={title} />
            </React.StrictMode>,
            element
        );
    }
})